import React, { CSSProperties, useMemo } from "react";
import { PermissionConstraints } from "@azure/communication-calling";
import { PcpPrimaryButton } from "../../BaseComponents";


const buttonMobileStyles: CSSProperties = {
    width: 'fit-content',
    height: '45px',
};

const buttonDesktopStyles: CSSProperties = {
    width: 'fit-content',
    height: '35px',
};

/**
 * Strings of {@link DevicePermissionDropdown} that can be overridden.
 */
export interface DevicePermissionDropdownStrings {
    /**
     * dropdown label
     */
    label?: string;
}

export interface DevicePermissionDropdownProps {
    /**
     * Ask for permissions of devices.
     *
     * @remarks
     * Browser permission window will pop up if permissions are not granted yet
     *
     * @param constrain - Define constraints for accessing local devices {@link @azure/communication-calling#PermissionConstraints }
     */
    askDevicePermission?(constrain: PermissionConstraints): Promise<void>;
    /**
     * Optional callback when component is clicked
     */
    onClick?: () => void;
    /**
     * Define constraints for accessing local devices  {@link @azure/communication-calling#PermissionConstraints }
     */
    constrain?: PermissionConstraints;

    isMobile: boolean;
}

/**
 * A dropdown to trigger device permission prompt
 */
export const DevicePermissionDropdown = (props: DevicePermissionDropdownProps): JSX.Element => {
    const { askDevicePermission, onClick, constrain } = props;

    const buttonStyles = useMemo(
        () => props.isMobile ? buttonMobileStyles : buttonDesktopStyles,
        [props.isMobile]
    );

    return (
        <PcpPrimaryButton
            data-ui-id={'permission-dropdown'}
            style={buttonStyles}
            onClick={() => {
                if (askDevicePermission) {
                    askDevicePermission(constrain ?? { video: true, audio: true });
                }
                onClick?.();
            }}
        >
            Erlauben
        </PcpPrimaryButton>
    );
};
